

























































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Language from "@/models/language/language.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import i18n from "@/Plugin/i18n.ts";
import { PermissionValue } from "@/enums/PermissionValue";
import TipoEvaluacion from '@/models/evaluacion/tipoEvaluacion.model';
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue"
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue"
import { ParesEvaluadoresTypes } from '@/enums/ParesEvaluadoresTypes';

@Component({
  components: {
    UserBasicInformationComponent, ResearchCenterBasicInformationComponent
  }
})
export default class EvaluationTypeTable extends GenericBTable<TipoEvaluacion> {
  isLoading = false;
  pertinencia: ParesEvaluadoresTypes = ParesEvaluadoresTypes.PERTINENCIA;
  cientificoTecnico: ParesEvaluadoresTypes = ParesEvaluadoresTypes.CIENTIFICOTECNICO;
  financiero: ParesEvaluadoresTypes = ParesEvaluadoresTypes.FINANCIERO;
  
  created() {
    this.permissionValue = PermissionValue.TIPOEVALUACION;
    this.tableConfig.controller = "TipoEvaluacion";
    this.formatColumns();
  }

  formatColumns() {
    let titulo = new BTableColumn("titulo", "table.researchCenterDescription", true);

    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.insertColumns(titulo);
    this.tableConfig.actions.customTemplate = true;
  }

  goToQestions(id: any, data: any) {
    this.$router.push(`/EvaluationType/${id}/Questions`);
  }
}
